import {
  Typography,
  Tag,
  Col,
  Popover,
  Spin,
  Modal,
  Pagination,
  Select,
  ConfigProvider,
  Input,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  Images,
} from "../../global";
import { Row, Icon, View, LoadingIcon, Graph, Alert } from "../../Components";
import { ReactComponent as nextArrowButton } from "../../Assets/SVG/NextArrowButton.svg";
import { ReactComponent as prevArrowButton } from "../../Assets/SVG/PrevArrowButton.svg";
import {
  Title,
  Text,
  Space,
  Paper,
  Group,
  Center,
  Button,
  Tooltip,
  ActionIcon,
  Loader,
  Table,
  Menu,
} from "@mantine/core";
import { IconPlus, IconSearch } from "@tabler/icons-react";
import { ReactComponent as lastNextArrowButton } from "../../Assets/SVG/LastNextArrowButton.svg";
import { ReactComponent as firstPrevArrowButton } from "../../Assets/SVG/FirstPrevArrowButton.svg";
import { useEffect, useState, useRef } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { useNavigate, useMatch } from "react-router-dom";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { useCookies } from "react-cookie";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { ReactComponent as optionsIcon } from "../../Assets/SVG/Options.svg";
import { ReactComponent as backIcon } from "../../Assets/SVG/Back.svg";
import {
  ToolTypes,
  getLiveGraphData,
  addGraphLiveData,
  updateToolSettings,
  saveSession,
  exportFile,
  newSheet,
  clearAlert as clearAlertAPI,
  clearAlerts as clearAlertsAPI,
  deleteAlerts as deleteAlertsAPI,
  addAlert as addAlertAPI,
  updateAlert,
  getSharedStores,
  getSharedStore,
  addProject,
  deleteProject,
  getProjects,
  updateProject,
  addProjectImage,
  getSenderShares,
} from "../../API";
import {
  THP_ENABLED_ARRAY,
  THP_CHANNEL_ICONS,
  THP_DEFAULT_Y_AXIS,
  THP_CH_ENUM,
  THP_ENABLED_CHANNELS,
} from "../../Tools/THP";
import HelperService from "../../Helpers/HelperService";
import { ResponsiveLine } from "@nivo/line";
import { Storage, Auth, Amplify } from "aws-amplify";
import _ from "lodash";
import { MdKeyboardArrowLeft } from "react-icons/md";
import StoreColumns from "../../Components/Column/StoreColumns";
import StoreAdd from "../Stores/StoreAdd";
import StoreEdit from "../Stores/StoreEdit";
import StoreOverview from "../Stores/StoreOverview";
import { BiDotsVertical } from "react-icons/bi";
import classes from "./Stores.module.css";


let defaultEn = [true, true, true, true, true, true];
let defaultEnAxis = [true, true, true, true, true, true];
let graphPropsDashboard = {
  enX: true,
  start: null,
  end: null,
  en: defaultEn,
  enY: defaultEnAxis,
  enYCount: 0,
  currZoom: { x: 0, scale: 1 },
  customScope: false,
};
const maxAttributes = 8;
let xdata = [];
// let multiplier = (previewWidth-20) / (xdata.length - 1)
let data = Array.from(Array(maxAttributes), () => new Array(0));
let yAxisEnabledCount = 0;
let tempUnits = Array.from(Array(maxAttributes), () => "");
let channels = new Array(maxAttributes);
let tempScopeAdjustment;
// let graphDataPulled = false
let tempData = [];
let TOOL_CH_ENUM = [];
let attributeArray;
let verticalLines = [];
let channelNames = [];
let channelUnits = [];
let channelValues = [];
let enabledChannels;
let tempChannelSelector = {};
let lastWidth;
let lastHeight;
let cloudUpperLimit;
let cloudLowerLimit;

function Sites() {
  const navigate = useNavigate();
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  const match = useMatch("/stores/:project_id");
  const matchEdit = useMatch("/stores/:project_id/edit");
  const project_id = window?.location?.pathname.includes("edit")
    ? matchEdit?.params.project_id
    : match?.params.project_id;
  console.log("project_id:", project_id);
  console.log("Store All Sites:", allSites);
  const { user } = useAuthenticator((context) => [context.user]);
  let email = "";
  if (user?.attributes?.email) email = user?.attributes?.email;
  const [currentStore, setCurrentStore] = useState();
  const ref = useRef();
  console.log("currentStore:", currentStore);
  const [cookies, setCookie] = useCookies([email]);
  const { Title } = Typography;
  const [displayData, setDisplayData] = useState([]);
  const [displayDataZoomed, setDisplayDataZoomed] = useState([]);
  const [chartUpdated, setChartUpdated] = useState(true);
  const [graphData, setGraphData] = useState({
    startOfData: 1690394385,
    data_id_createdAt: 1690394385,
    totalRecordCount: 0,
    updatedAt: HelperService.getEpoch(new Date()),
    data: [],
    rawData: [],
    convertedData: [],
    normalData: [],
  });
  const [expandedSensor, setExpandedSensor] = useState([]);
  const [showGraphProps, setShowGraphProps] = useState(false);
  const [shareFile, setShareFile] = useState(false);
  const [enabled, setEnabled] = useState(
    graphPropsDashboard.en
      ? graphPropsDashboard.en.map((attribute) => attribute)
      : defaultEn
  );
  const [xdataZoomed, setXdataZoomed] = useState(xdata);
  const [fullscreen, setFullscreen] = useState(false);
  const [startOfData, setStartOfData] = useState(graphData.startOfData);
  const [scope, setScope] = useState("week");
  const [scopeAdjustment, setScopeAdjustment] = useState({
    live: 0,
    day: 0,
    week: 0,
    month: 0,
    all: 0,
    custom: 0,
  });
  const [startTime, setStartTime] = useState(
    displayDataZoomed[0]?.data != undefined &&
      displayDataZoomed[0]?.data.length > 0 &&
      displayDataZoomed[0]?.data[0]?.x != undefined
      ? displayDataZoomed[0]["data"][0]["x"]
      : undefined
  );
  const [customStartTime, setCustomStartTime] = useState(
    startTime ? startTime : new Date()
  );
  const [stopTime, setStopTime] = useState(
    displayDataZoomed[0]?.data[displayDataZoomed[0]?.data.length - 1] !=
      undefined
      ? displayDataZoomed[0]["data"][displayDataZoomed[0]?.data.length - 1]["x"]
      : undefined
  );
  const [customStopTime, setCustomStopTime] = useState(
    stopTime ? stopTime : new Date()
  );
  const [enabledAxis, setEnabledAxis] = useState(graphPropsDashboard.enY);
  const [height, setHeight] = useState(400);
  const [width, setWidth] = useState(lastWidth);
  const [loading, setLoading] = useState(true);
  const [upper, setUpper] = useState();
  const [lower, setLower] = useState();
  const [upperAlert, setUpperAlert] = useState();
  const [lowerAlert, setLowerAlert] = useState();
  const [storeName, setStoreName] = useState();
  const [storeNumber, setStoreNumber] = useState();
  const [storeAddress, setStoreAddress] = useState();
  const [storeManager, setStoreManager] = useState();
  const [createStoreLoading, setCreateStoreLoading] = useState(false);
  const [deleteStoreLoading, setDeleteStoreLoading] = useState(false);
  const [updateStoreLoading, setUpdateStoreLoading] = useState(false);
  const [deleteStore, setDeleteStore] = useState(false);
  const [image, setImage] = useState(null);
  const [imageUpdate, setImageUpdate] = useState(null);
  const [filteredSearch, setFilteredSearch] = useState(null);
  const [filteredAllStoreSearch, setFilteredAllStoreSearch] = useState(null);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const { Option } = Select;

  

  let enabledCount = 0;
  enabled.forEach((attribute) => {
    if (attribute) enabledCount++;
  });

  const repullStores = async () => {
    let tempAllSites = _.cloneDeep(allSites);
    tempAllSites.stores = await getProjects();
    setAllSites(tempAllSites);
    setFilteredAllStoreSearch(tempAllSites);
  };

  const handleImageUpload = async (projectId) => {
    console.log("handleImageUpload");
    if (imageUpdate) {
      console.log("imageUpdate:", imageUpdate);
      try {
        const result = projectId
          ? await addProjectImage(
              projectId,
              imageUpdate.image,
              imageUpdate.contentType
            )
          : await addProjectImage(
              project_id,
              imageUpdate.image,
              imageUpdate.contentType
            );

        console.log("Image uploaded successfully:", result);
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    } else {
      console.error("No file selected");
    }
  };

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const CustomPoint = (props) => {
    const { currentSlice } = props;
    console.log("CustomPoint props:", props);
    // it will show the current point
    if (currentSlice) {
      return (
        <g>
          <line
            x1={currentSlice.points[0].x}
            x2={currentSlice.points[0].x}
            y1={0}
            y2={height - 114}
            stroke={Colors.lightGrey}
            strokeWidth="1"
            strokeDasharray={[6, 3]}
          />
          {currentSlice.points.map((point) => {
            if (point.id.includes("upper") || point.id.includes("lower"))
              return <></>;
            return (
              <circle
                fill={Colors.darkGrey}
                r={3}
                strokeWidth={1}
                stroke={Colors.white}
                fillOpacity={1}
                cx={point.x}
                cy={point.y}
              />
            );
          })}
        </g>
      );
    }
  };

  const getGraphData = (tool, dataID, scope, attributeArray, allSites) => {
    let graphStore = "weekScope";
    const tempGraphData = _.get(allSites, graphStore, {});
    console.log("tempGraphData:", tempGraphData);
    let myGraphData;
    if (!_.isEmpty(tempGraphData)) {
      //Go through the list of tools
      tempGraphData.forEach((toolData, key) => {
        //find the tool in the state
        if (_.isEqual(key, dataID)) {
          myGraphData = toolData.normalData;
          setGraphData(toolData);
          setStartOfData(toolData.startOfData);
          console.log("CURRENT GRAPH DATA:", toolData);
          // _.assign(myGraphData, toolData)//assign to returned tool object
        }
      });
    }
    console.log("myGraphData:", myGraphData);
    if (myGraphData == undefined) return [];
    let convertedItems = [];
    xdata = [];
    attributeArray.forEach((attribute, i) => {
      if (i > 0 && attribute == "sthp_temp") {
        //Only build temp data
        convertedItems[0] = {
          id: attribute,
          color: Colors.greenMain,
          data: [],
        };
        convertedItems[1] = { id: "upper", color: Colors.orangeMain, data: [] };
        convertedItems[2] = { id: "lower", color: Colors.redMain, data: [] };
        let currentData = new Array();
        let upperData = [];
        let lowerData = [];
        myGraphData.forEach((item, index) => {
          let date = new Date(item[0] * 1000);
          if (isNaN(Number(item[i]))) {
            currentData.push({ x: date, y: null });
          } else {
            currentData.push({ x: date, y: item[i] });
          }
          if (_.has(tool, "alerts") && tool.alerts.length > 0) {
            tool.alerts.forEach((alert) => {
              if (
                alert.alertMode == "sensorMode" &&
                alert.settings.alertEnable == true &&
                alert.settings.testField == "sthp_temp"
              ) {
                let normalTestValue = alert.settings.testValue;
                let toolData = tempGraphData.get(dataID);
                console.log("toolData:", toolData);
                if (enabledAxis && enabledAxis[0].max != enabledAxis[0].min) {
                  normalTestValue =
                    !isNaN(alert.settings.testValue) &&
                    alert.settings.testValue != null
                      ? (alert.settings.testValue - enabledAxis[0].min) /
                        (enabledAxis[0].max - enabledAxis[0].min)
                      : alert.settings.testValue;
                }
                console.log("normalTestValue:", normalTestValue);
                if (alert.settings.testCondition == "GT") {
                  if (_.isEqual(upperAlert, undefined)) {
                    cloudUpperLimit = alert.settings.testValue;
                    setUpper(alert.settings.testValue);
                    setUpperAlert(alert.alert_id);
                  }
                  console.log("new entry:", { x: date, y: normalTestValue });
                  upperData.push({ x: date, y: normalTestValue });
                  console.log("upperData:", upperData);
                }
                if (alert.settings.testCondition == "LS") {
                  if (_.isEqual(lowerAlert, undefined)) {
                    cloudLowerLimit = alert.settings.testValue;
                    setLower(alert.settings.testValue);
                    setLowerAlert(alert.alert_id);
                  }
                  console.log("new entry:", { x: date, y: normalTestValue });
                  lowerData.push({ x: date, y: normalTestValue });
                  console.log("lowerData:", lowerData);
                }
              }
            });
          }
          if (i == 1) xdata.push(item[0]);
        });
        console.log("currentData:", currentData);
        console.log("upperData:", upperData);
        console.log("lowerData:", lowerData);
        convertedItems[0]["data"] = currentData;
        convertedItems[1]["data"] = upperData;
        convertedItems[2]["data"] = lowerData;
      }
    });
    setChartUpdated(true);
    setXdataZoomed(xdata);
    console.log("xdata length:", xdata.length);
    // multiplier = (previewWidth-20) / (xdata.length - 1)
    console.log("convertedItems:", convertedItems);

    return convertedItems;
  };

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      console.log("RESIZE:", entries[0].contentRect);
      if (entries[0].contentRect.width > 0) {
        // && entries[0].contentRect.height > 0
        console.log("New Width:", entries[0].contentRect.width);
        console.log("New Height:", entries[0].contentRect.height);
        setWidth(entries[0].contentRect.width);
        // setHeight(entries[0].contentRect.height)
        lastHeight = entries[0].contentRect.height;
        lastWidth = entries[0].contentRect.width;
      }
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => ref.current && observer.unobserve(ref.current);
  }, [ref.current, enabled, enabledAxis, fullscreen, expandedSensor]);

  useEffect(() => {
    let tempStore = _.find(allSites?.stores?.Items, function (o) {
      return o.project_id === project_id;
    });
    
    if (tempStore) {
      setCurrentStore(tempStore);
      setFilteredSearch(_.cloneDeep(tempStore));
      setStoreName(tempStore?.settings?.projectName);
      setStoreNumber(tempStore?.settings?.projectIdentifier);
      setStoreAddress(tempStore?.settings?.projectLocation);
      setStoreManager(tempStore?.settings?.projectOwner);
      setImage(tempStore?.settings?.projectImageURL);
      setImageUpdate(null);
    } else {
      setCurrentStore();
      setFilteredSearch();
      setStoreName();
      setStoreNumber();
      setStoreAddress();
      setStoreManager();
      setImage(null);
      setImageUpdate(null);
      setCurrentStore(null);
    }
  }, [project_id, allSites?.stores?.Items]);

  useEffect(() => {
    console.log("Updating AllSites to ", {
      ...allSites,
      fullscreen: fullscreen,
    });
    if (!_.isEqual({ ...allSites, fullscreen: fullscreen }, allSites)) {
      setAllSites({ ...allSites, fullscreen: fullscreen });

      setFilteredAllStoreSearch({ ...allSites, fullscreen: fullscreen });
    }
  }, [fullscreen]);

  useEffect(() => {
    let tool;
    setDisplayDataZoomed([]);
    setXdataZoomed([]);
    setLoading(true);
    if (expandedSensor.length > 0) {
      tool = currentStore[expandedSensor[0]];
      console.log("currStore", currentStore[expandedSensor[0]]);
    }

    const getLiveGraphDataEffect = async () => {
      console.log("getLiveGraphData useEffect:", allSites);
      if (tool != undefined && tool.toolType == ToolTypes.THP) {
        attributeArray = ["ts"].concat(...THP_CH_ENUM);
        apiAttributes = attributeArray.join();
        // if(!graphDataPulled){
        console.log("getLiveGraphData useEffect:", allSites);
        await addGraphLiveData(
          { ...allSites },
          setAllSites,
          user.signInUserSession.idToken.jwtToken,
          tool,
          scope,
          scopeAdjustment[scope],
          { start: customStartTime, end: customStopTime },
          null
        );
        // graphDataPulled = true;
        let temp = [];
        if (_.has(tool, "data_id")) {
          temp = getGraphData(tool, tool.data_id, scope, attributeArray, {
            ...allSites,
          });
        } else if (_.has(tool, "share_id")) {
          temp = getGraphData(tool, tool.share_id, scope, attributeArray, {
            ...allSites,
          });
        }
        if (temp.length > 0) tempData = temp;

        let tempDisplayData = [];
        console.log("Setting Display Data.");
        console.log("tempData:", tempData);
        console.log("enabled:", enabled);
        tempData.forEach((attribute, index) => {
          if (
            enabled[index] ||
            attribute.id == "upper" ||
            attribute.id == "lower"
          ) {
            tempDisplayData[index] = attribute;
          } else {
            tempDisplayData[index] = attribute;
            attribute.data.forEach((point, i) => {
              tempDisplayData[index].data[i] = { x: point.x, y: null };
            });
          }
        });
        if (tool != undefined) {
          console.log("Tool:", tool);
          defaultEn = THP_ENABLED_ARRAY(tool, null);
          defaultEnAxis = THP_DEFAULT_Y_AXIS(tool.settings.channels);
          // if(!_.isEqual(defaultEnAxis,enabledAxis)) setEnabledAxis(defaultEnAxis)
          yAxisEnabledCount = 0;
          console.log("enabled:", enabled);
          console.log("enabledAxis:", enabledAxis);
          defaultEnAxis.forEach((axis) => {
            if (
              axis.enabled &&
              axis.channels.some((channel) => enabled[channel] == true)
            ) {
              console.log("Axis enabled!", axis);
              yAxisEnabledCount++;
            }
          });
          console.log("defaultEnAxis:", defaultEnAxis);

          if (
            tool.mac &&
            _.has(tool, "settings") &&
            _.has(tool.settings, "graphPropsDashboard") &&
            !_.isEmpty(tool.settings.graphPropsDashboard)
          ) {
            console.log("tool graph props");
            if (!_.has(tool.settings.graphPropsDashboard, "enY")) {
              tool.settings.graphPropsDashboard.enY = defaultEnAxis;
            }
            graphPropsDashboard = tool.settings.graphPropsDashboard;
          } else {
            console.log("default tool graph props");
            graphPropsDashboard = {
              enX: true,
              start: null,
              end: null,
              en: defaultEn,
              enY: defaultEnAxis,
              enYCount: defaultEnAxis.length,
              currZoom: { x: 0, scale: 1 },
              customScope: false,
            };
          }
          setEnabledAxis(graphPropsDashboard.enY);
          console.log("defaultEn:", defaultEn);
        } else {
          console.log("Can't change Y Axis. Tool:", tool);
        }
        console.log("tempDisplayData:", tempDisplayData);
        setDisplayDataZoomed(tempDisplayData);
        setChartUpdated(true);
        channels[0] = tool.settings.channels.sthp_temp.name;
        tempUnits[0] = tool.settings.channels.sthp_temp.unit;
        channelValues[0] = tool.sensor.sthp_temp;
        channelNames[0] = "sthp_temp";
        if (allSites.graphUpdated) setLoading(false);
      }
    };
    let apiAttributes;
    try {
      if (
        user &&
        tool &&
        _.has(user, "signInUserSession") &&
        _.has(user.signInUserSession, "idToken") &&
        _.has(user.signInUserSession.idToken, "jwtToken")
      ) {
        getLiveGraphDataEffect();
      } else {
        console.log("Can't pull data yet");
      }
    } catch (error) {
      console.log("unexpected error...");
    }
    if (tool?.toolType) {
      if (!ToolTypes.THP.localeCompare(tool.toolType)) {
        enabledChannels = THP_ENABLED_CHANNELS(tool, false);
      }
      tempChannelSelector = {};
      enabledChannels.forEach((channel) => {
        _.set(tempChannelSelector, channel, true);
      });
    }
  }, [
    expandedSensor,
    currentStore,
    allSites,
  ]);

  const rows = allSites.stores?.Items?.map((store) => {
    // Check if there are any tools in the store
    const hasTools = store.tools.length > 0;

    // If there are tools, check for alarms
    const hasAlarm =
      hasTools &&
      store.tools.some((address) => {
        const tool = store[address];
        return tool && tool.alerts && tool.alerts.length > 0;
      });

    const status = hasAlarm ? "Alarm" : "OK";
    const rowColor = {
      backgroundColor:
        status === "Alarm" ? Colors.errorLight : Colors.successLight,
    };

    return (
      <>
        <Table.Tr
          key={store.project_id}
          onClick={() => navigate(`/stores/${store.project_id}`)}
        >
          <Table.Td style={rowColor}>
            <Text size="sm" ta="center">
              {status}
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="sm" ta="center">
              {store.settings.projectIdentifier}
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="sm" ta="center">
              {store.settings.projectName}
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="sm" ta="center">
              Domino's Pizza
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="sm" ta="center">
              {store.tools.length}
            </Text>
          </Table.Td>
          <Table.Td w={10} visibleFrom="sm">
            <Center>
              <Menu
                shadow="md"
                trigger="click-hover"
                classNames={{
                  item: classes.item,
                }}
              >
                <Menu.Target>
                  <ActionIcon
                    variant="subtle"
                    color={Colors.main}
                    size="lg"
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                  >
                    <BiDotsVertical />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown w={100}>
                  <Menu.Item
                    onClick={(event) => {
                      event.stopPropagation();
                      navigate(`/stores/${store.project_id}`);
                    }}
                  >
                    Details
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Center>
          </Table.Td>
        </Table.Tr>

        {}
      </>
    );
  });

  
  return window?.location?.pathname.includes("add") ? (
    StoreAdd(
      storeName,
      setStoreName,
      storeNumber,
      setStoreNumber,
      storeAddress,
      setStoreAddress,
      storeManager,
      setStoreManager,
      image,
      createStoreLoading,
      setCreateStoreLoading,
      handleImageUpload,
      repullStores,
      navigate,
      addProject,
      setImageUpdate,
      user
    )
  ) : window?.location?.pathname.includes("edit") ? (
    StoreEdit(
      navigate,
      project_id,
      storeName,
      setStoreName,
      storeNumber,
      setStoreNumber,
      storeAddress,
      setStoreAddress,
      storeManager,
      setStoreManager,
      image,
      setImageUpdate,
      setDeleteStore,
      setDeleteStoreLoading,
      deleteStoreLoading,
      deleteProject,
      setUpdateStoreLoading,
      updateStoreLoading,
      updateProject,
      deleteStore,
      handleImageUpload,
      repullStores,
      user,
      getSenderShares,
      currentStore,
      allSites
    )
  ) : project_id && !currentStore ? (
    <Center>
      <Loader color={Colors.main} />
    </Center>
  ) : project_id ? (
    StoreOverview(
      currentStore,
      navigate,
      project_id,
      allSites,
      setAllSites,
      expandedSensor,
      setExpandedSensor,
      ref,
      enabledAxis,
      xdataZoomed,
      displayDataZoomed,
      height,
      width,
      tempUnits,
      loading,
      graphData,
      chartUpdated,
      ResponsiveLine,
      enabledCount,
      attributeArray,
      CustomPoint,
      enabled,
      verticalLines,
      onChange,
      filteredSearch,
      setFilteredSearch,
      user,
      setRefreshLoading,
      refreshLoading
    )
  ) : (
    <>
      <Group justify="space-between">
        <div>
          <Title order={2}>Stores</Title>
          <Text mt="-lg" c="dimmed" size="sm">
            Select a store for more details.
          </Text>
        </div>
      </Group>

      <Space h="lg" />

      {!allSites.stores ? (
        <Center>
          <Loader color={Colors.main} />
        </Center>
      ) : allSites?.stores?.Items.length > 0 ? (
        <>
          <Paper radius="sm">
            <Group p="xs">
              <Input
                placeholder="Search Records..."
                prefix={<SearchOutlined style={{ color: "#263CAB" }} />}
                style={{ width: 200, backgroundColor: "#F7F7F9" }}
                onChange={(e) => {
                  const searchText = e.target.value;
                  // Add your search logic here
                }}
              />
            </Group>

            <Paper withBorder radius="sm">
              <Table
                withColumnBorders
                stickyHeader
                verticalSpacing="md"
                highlightOnHover
              >
                <Table.Thead style={{ backgroundColor: "#DDDDDF" }}>
                  <Table.Tr>
                    <Table.Th>
                      <Center>Store Status</Center>
                    </Table.Th>
                    <Table.Th>
                      <Center>Store Number</Center>
                    </Table.Th>
                    <Table.Th>
                      <Center>Store Name</Center>
                    </Table.Th>
                    <Table.Th>
                      <Center>Account</Center>
                    </Table.Th>
                    <Table.Th>
                      <Center>Sensor Count</Center>
                    </Table.Th>
                    <Table.Th visibleFrom="sm">
                      <Center>Actions</Center>
                    </Table.Th>
                  </Table.Tr>
                </Table.Thead>

                <Table.Tbody
                  style={{ backgroundColor: "#FFFFFF", cursor: "pointer" }}
                >
                  {rows}
                </Table.Tbody>
              </Table>
            </Paper>
          </Paper>
        </>
      ) : (
        <Center>
          <Text>
            No stores available. Add one by clicking the '+' to the right.
          </Text>
        </Center>
      )}
    </>
  );
}

export default Sites;